/* eslint-disable prefer-destructuring */
import axios, { AxiosRequestConfig } from "axios";
import keycloak from "../Keycloak/Keycloak";
import { apiUrl } from "../url";
const customAxios = axios.create({
    timeout: 130000,
    headers: { "Content-Type": "application/json" },
});
const publicAxios = axios.create({
    timeout: 130000,
    headers: { "Content-Type": "application/json" },
});
customAxios.interceptors.request.use(
    (config) => {
        const isFormData =
            typeof FormData !== "undefined" && config.data instanceof FormData;

        if (isFormData) {
            delete config.headers["Content-Type"];
            delete config.headers["content-type"];
            delete config.headers.ContentType;
        } else {
            config.headers["Content-Type"] = "application/json";
        }
        const token = keycloak.token;

        if (token) {
            config.headers.Authorization = `bearer ${token}`;
        }
        return Promise.resolve(config);
    },
    (error) => Promise.reject(error)
);

customAxios.defaults.baseURL = apiUrl
publicAxios.defaults.baseURL = apiUrl;

export default class APIService {
    public static baseUrl = `${process.env.REACT_APP_SERVER_API}/`;

    public static async HandleGetRequest<Type>(
        resourceUrl: string
    ): Promise<Type> {
        const request: Type = (await customAxios.get<Type>(resourceUrl)).data;

        return request;
    }

    public static async handlePostRequest<Type, ReturnType>(
        data: Type,
        resourceUrl: string,
        config?: AxiosRequestConfig | undefined
    ): Promise<ReturnType> {
        const request: ReturnType = (
            await customAxios.post<ReturnType>(resourceUrl, data, config)
        ).data;

        return request;
    }

    public static async userInfo<Type, ReturnType>(
        data: Type,
        resourceUrl: string
    ): Promise<ReturnType> {
        const request: ReturnType = (
            await customAxios.post<ReturnType>(resourceUrl, data)
        ).data;

        return request;
    }

    public static async handlePublicPostRequest<Type, ReturnType>(
        data: Type,
        resourceUrl: string
    ): Promise<ReturnType> {
        const request: ReturnType = (
            await publicAxios.post<ReturnType>(resourceUrl, data)
        ).data;

        return request;
    }

    public static async handleDeleteRequest<Type, ReturnType>(
        data: Type,
        resourceUrl: string
    ): Promise<ReturnType> {
        const response =
            data === null || data === undefined
                ? await customAxios.delete<ReturnType>(resourceUrl)
                : await customAxios.delete<ReturnType>(resourceUrl, {
                      data,
                  });

        return response.data;
    }

    public static async handlePatchRequest<Type, ReturnType>(
        data: Type,
        resourceUrl: string
    ): Promise<ReturnType> {
        /*
         * The body must be omitted rather than passed as null: the request
         * interceptor above always sets Content-Type: application/json, so
         * axios serializes null to the literal string "null", which the
         * server's JSON body parser rejects with a 400 (entity.parse.failed)
         * before the request ever reaches the route. handleDeleteRequest
         * guards against the same trap.
         */
        const response =
            data === null || data === undefined
                ? await customAxios.patch<ReturnType>(resourceUrl)
                : await customAxios.patch<ReturnType>(resourceUrl, data);

        return response.data;
    }
}
